/**
 * 学习乐园 · 连连看题材包：算式配对（lianliankan/pack-suanli.js）
 * ---------------------------------------------------------------------------
 * 全局注册式（构建是逐文件 minify、不开 bundle，见 build-assets.mjs 文件头）：
 * footer 按 config/study.php 的 packs 字段按需加载，defer 按文档顺序执行——
 * 所有 pack 先于 game-lianliankan.min.js 就位，主引擎 boot 时题材已齐。
 *
 * 包字段约定（每个题材包一致）：
 *   id / name / hint   题材标识与选择器按钮文案
 *   kind 'rel'         关联型：左右牌面不同，按 pair 配对（算式连结果）
 *   cols / rows        棋盘尺寸（格数必须偶数；pairs 数 ≥ cols*rows/2）
 *   pairs[].l / r      牌面文本；note = 配错时给出的口诀/释义（可选）
 * 新增题材 = 复制本文件改数据，再在 config/study.php 的 packs 里加一项。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.suanli = {
    id: 'suanli',
    name: '算式配对',
    hint: '乘法口诀：算式连结果',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '2×3', r: '6',  note: '二三得六' },
      { l: '2×5', r: '10', note: '二五一十' },
      { l: '2×7', r: '14', note: '二七十四' },
      { l: '2×8', r: '16', note: '二八十六' },
      { l: '2×9', r: '18', note: '二九十八' },
      { l: '3×4', r: '12', note: '三四十二' },
      { l: '3×6', r: '18', note: '三六十八' },
      { l: '3×7', r: '21', note: '三七二十一' },
      { l: '3×8', r: '24', note: '三八二十四' },
      { l: '3×9', r: '27', note: '三九二十七' },
      { l: '4×4', r: '16', note: '四四十六' },
      { l: '4×5', r: '20', note: '四五二十' },
      { l: '4×6', r: '24', note: '四六二十四' },
      { l: '4×7', r: '28', note: '四七二十八' },
      { l: '4×9', r: '36', note: '四九三十六' },
      { l: '5×6', r: '30', note: '五六三十' },
      { l: '5×7', r: '35', note: '五七三十五' },
      { l: '5×8', r: '40', note: '五八四十' },
      { l: '5×9', r: '45', note: '五九四十五' },
      { l: '6×7', r: '42', note: '六七四十二' },
      { l: '6×8', r: '48', note: '六八四十八' },
      { l: '6×9', r: '54', note: '六九五十四' },
      { l: '7×7', r: '49', note: '七七四十九' },
      { l: '7×8', r: '56', note: '七八五十六' },
      { l: '7×9', r: '63', note: '七九六十三' },
      { l: '8×9', r: '72', note: '八九七十二' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
